import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useUpdateProfile = (id) => {
  const { client } = useContext(AxiosContext);

  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    updateProfile: useMutation(
      (params) =>
        client.patch(`profiles/${id}/`, params).then((res) => res.data),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("profile");
        },
      }
    ),
    error: error,
  };
};

export default useUpdateProfile;
